//Automatically Post Changes
//(function($) {

//  $.fn.railsSortable = function(options) {
//    options = options || {};
 //   var settings = $.extend({}, options);

//    settings.update = function(event, ui) {
//      if (typeof options.update === 'function') {
//        options.update(event, ui);
//      }

      
 //     $.ajax({
 //       type: 'POST',
 //       url: '/sortable/reorder',
 //       dataType: 'json',
 //       contentType: 'application/json',
 //       data: JSON.stringify({
 //         rails_sortable: $(this).sortable('toArray'),
 //       }),
  //    });
 //   }

 //   this.sortable(settings);
 // };
//})(jQuery);

// Don't save automatically

(function ($) {
  $.fn.railsSortable = function (options) {
    options = options || {};
    var settings = $.extend({}, options);

    settings.update = function (event, ui) {
      if (typeof options.update === "function") {
        options.update.call(this, event, ui);
      }
      // IMPORTANT: no ajax here
    };

    this.sortable(settings);
    return this;
  };
})(jQuery);

function syncPackSort($container) {
  $container.find(".packs-nested-fields").each(function (idx) {
    $(this).find("input.js-pack-sort").val(idx + 1);
  });
}

function initPackSortable($container) {
  if (!$container.length) return;
  if ($container.data("packs-sortable-initialized")) return;
  $container.data("packs-sortable-initialized", true);

  $container.railsSortable({
    handle: ".drag-handle",              // use what you actually grab
    items: ".packs-nested-fields",       // be explicit
    cancel: "input,textarea,select,option,button,a",
    tolerance: "pointer",
    update: function () {
      syncPackSort($container);
      window.unsaved = true;
    }
  });

  syncPackSort($container);
}

$(document).on("turbolinks:load", function () {
  $(".pack-sortable").each(function () {
    initPackSortable($(this));
  });
});

// IMPORTANT: use insertedItem
$(document).on("cocoon:after-insert", function (e, insertedItem) {
  const $container = $(insertedItem).closest(".pack-sortable");
  if (!$container.length) return;

  // make sure sortable knows about the new DOM node
  initPackSortable($container);          // in case it wasn't initialised
  $container.sortable("refresh");
  syncPackSort($container);

  window.unsaved = true;
});

$(document).on("cocoon:after-remove", function (e, removedItem) {
  const $container = $(removedItem).closest(".pack-sortable");
  if (!$container.length) return;

  $container.sortable("refresh");
  syncPackSort($container);
  window.unsaved = true;
});
